var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_3508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4462 3.11182H5.55825C4.20849 3.11182 3.11429 4.20602 3.11429 5.55578V10.4437C3.11429 11.7935 4.20849 12.8877 5.55825 12.8877H10.4462C11.7959 12.8877 12.8901 11.7935 12.8901 10.4437V5.55578C12.8901 4.20602 11.7959 3.11182 10.4462 3.11182Z",
    stroke: "#222222",
    strokeWidth: 1.09978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00222 9.83294C9.01455 9.83294 9.8352 9.01229 9.8352 7.99996C9.8352 6.98764 9.01455 6.16699 8.00222 6.16699C6.9899 6.16699 6.16925 6.98764 6.16925 7.99996C6.16925 9.01229 6.9899 9.83294 8.00222 9.83294Z",
    stroke: "#222222",
    strokeWidth: 0.916486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7517 5.25049V5.25085",
    stroke: "#222222",
    strokeWidth: 0.916486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_3508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6638,
    height: 14.6638,
    fill: "white",
    transform: "translate(0.670338 0.667969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.de9be30d1dfd455a9c7169b529e7bd07.svg";
export { ForwardRef as ReactComponent };